import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProveedoresService } from '../../../service/proveedores/proveedores.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';
import { lastValueFrom } from 'rxjs';


@Component({
  selector: 'app-visualizar-registro-proveedor-dialog',
  templateUrl: './visualizar-registro-proveedor-dialog.component.html',
  styleUrl: './visualizar-registro-proveedor-dialog.component.scss'
})
export class VisualizarRegistroProveedorDialogComponent {

  proveedorForm: FormGroup
  model
  editMode = true
  errorValidarCorreo = false
  headerTitle = 'Datos de Proveedor'
  gallery = {
    group1: true,
    group2: false,
    group3: false,
    group4: false,
    group5: false
  };
  mostrarError = {
    nombre: false,
    razonSocial: false,
    rfc: false,
    moneda: false,
    correo: false,
    direccion: false,
    telefono: false,
    contacto: false,
    noCuenta: false, 
    tipoCompra: false,
    tipoPersona: false,
    regimenFiscal: false,
    condicionesPago: false,
    diasPago: false,
    titular: false,
    idCif:false 
  }
  paises = []
  estados = []
  tipoMoneda = []
  formasPago = []
  bancos = []
  tipoCompra = []
  regimenFiscal = []
  condicionesPago = []
  estatus = []
  tipoPersona = []
  empresas = []
  empresaSelect = []
  loadingView = true
  step = 1
  validEmail = false

  selectedFile: File | null = null;
  pdfSrc: any = '';
  pdfName: any = ''
  selectedFile2: File | null = null;
  pdfSrc2: any = '';
  pdfName2: any = ''
  selectedFile3: File | null = null;
  pdfSrc3: any = '';
  pdfName3: any = ''
  selectedFile4: File | null = null;
  pdfSrc4: any = '';
  pdfName4: any = ''
  pdfSrc5: any = '';
  pdfName5: any = '';
  monedaSelect = []
  condicionPagoId: number;

  show(groupName) {
    this.gallery.group1 = (groupName == 'group1') ? true : false;
    this.gallery.group2 = (groupName == 'group2') ? true : false;
    this.gallery.group3 = (groupName == 'group3') ? true : false;
    this.gallery.group5 = (groupName == 'group5') ? true : false;
  }
  constructor( 
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) 
    public data: any, 
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private provedorService: ProveedoresService,
    public dialogRef: MatDialogRef<VisualizarRegistroProveedorDialogComponent>) {
      this.proveedorForm = this.fb.group({
        clave: ['', [Validators.required]],
        nombre: ['', [Validators.required]],
        //razonSocial: ['', [Validators.required]],
        razonSocial: [{value:'', disabled: true}],
        tipo: ['', [Validators.required]],
        rfc: ['', [Validators.required]],
        moneda: ['', [Validators.required]],
        direccion: ['', [Validators.required]],
        telefono: ['', [Validators.required]],
        correo: ['', [Validators.required]],
        contacto: ['', [Validators.required]],
        noCuenta: ['', [Validators.required]],
        condicionesPago: ['', [Validators.required]],
        tipoCompra: ['', [Validators.required]],
        tipoPersona: ['', [Validators.required]],
        regimenFiscal: ['', [Validators.required]],
        diasPago: ['', [Validators.required]],
        formasPago: ['', [Validators.required]],
        titular: ['', [Validators.required]],
        estatus: ['', [Validators.required]],
        banco: ['', [Validators.required]],
        idRfc: ['', [Validators.required]]
      })

      this.editMode = data.editable
      this.getTipoMoneda()
      this.getTipoCompra()
      //this.getFormasPago()
      this.getCondicionesPago()
      this.getEstatus()
      this.getRegimenFiscal()
      this.getTipoPersona()
      this.getBancos()
      this.getProveedorData(data.proveedor)
      this.getEmpresas()
      if(data.mostrarDocumentos){
        this.step = 4
      }
  }

  ngOnInit() {

  }

  getEmpresas(){
    this.provedorService.getEmpresas(localStorage.getItem('id')).subscribe(
      data => {
        this.empresas = data
      }
    )
  }
  getTipoMoneda(){
    this.provedorService.getTiposMoneda().subscribe(
      data => {
        this.tipoMoneda = data
      }
    )
  }

  getBancos(){
    this.provedorService.getBancos().subscribe(
      data => {
        this.bancos = data
      }
    )
  }
  
  getTipoCompra(){
    this.provedorService.getTiposCompra().subscribe(
      data => {
        this.tipoCompra = data
      }
    )
  }

  getEstatus(){
    this.provedorService.getProveedoresEstatus().subscribe(
      data => {
        this.estatus = data
      }
    )
  }

  getFormasPago(id, formaPagoId){

    this.provedorService.getFormaPago(id).subscribe(
      data => {
        this.formasPago = data
        this.proveedorForm.get('formasPago').setValue(formaPagoId);
      }
    )
  }

  getCondicionesPago(){
    this.provedorService.getCondicionesPago().subscribe(
      data => {
        this.condicionesPago = data
      }
    )
  }

  getRegimenFiscal(){
    this.provedorService.getRegimenFiscal().subscribe(
      data => {
        this.regimenFiscal = data
      }
    )
  }

  getTipoPersona(){
    this.provedorService.getTipoPersona().subscribe(
      data => {
        this.tipoPersona = data
      }
    )
  }

  getProveedorData(proveedor){
    this.provedorService.getProveedorPorClave(proveedor.claveProveedor).subscribe(
      datos => {
        let data = datos[0]
        this.proveedorForm = this.fb.group({
          clave: new FormControl({value: data.claveProveedor, disabled: true}, [Validators.required]),
          nombre: new FormControl({value: data.nombreProveedor, disabled: true}, [Validators.required]),
          razonSocial: new FormControl({value: data.razonSocial, disabled: true}, [Validators.required]),
          rfc: new FormControl({value: data.rfc, disabled: true}, [Validators.required]),
          moneda: new FormControl({value: data.moneda, disabled: true}, [Validators.required]),
          direccion: new FormControl({value: data.direccion, disabled: true}, [Validators.required]),
          telefono: new FormControl({value: data.telefono, disabled: true}, [Validators.required]),
          correo: new FormControl({value: data.email, disabled: true}, [Validators.required]),
          ciudad: new FormControl({value: data.ciudad, disabled: true}, [Validators.required]),
          pais: new FormControl({value: data.paisId, disabled: true}, [Validators.required]),
          estado: new FormControl({value: data.entidadId, disabled: true}, [Validators.required]),
          codigoPostal: new FormControl({value: data.codigoPostal, disabled: true}, [Validators.required]),
          contacto: new FormControl({value: data.contactoFacturacion, disabled: true}, [Validators.required]),
          noCuenta: new FormControl({value: data.numerodeCuenta, disabled: true}, [Validators.required]),
          condicionesPago: new FormControl({value: data.condiciondePagoId, disabled: true}, [Validators.required]),
          tipoCompra: new FormControl({value: data.tipoCompra, disabled: true}, [Validators.required]),
          diasPago: new FormControl({value: data.diasdePago, disabled: true}, [Validators.required]),
          tipoPersona: new FormControl({value: data.tipoProveedor, disabled: true}, [Validators.required]),
          regimenFiscal: new FormControl({value: data.regimenFiscal, disabled: true}, [Validators.required]),
          formasPago: new FormControl({value: data.formaPagoId, disabled: true}, [Validators.required]),
          titular: new FormControl({value: data.nombreTitular, disabled: true}, [Validators.required]),
          estatus: new FormControl({value: data.estatus, disabled: true}, [Validators.required]),
          banco:  new FormControl({value: data.bancosId, disabled: true}, [Validators.required]),
          idRfc:  new FormControl({value: data.idCIF, disabled: true}, [Validators.required]),
        })
         data.tiposMonedaProveedor.forEach(element => {
          this.monedaSelect.push(element.tipoMonedaId)
        });
        data.proveedorEmpresa.forEach(element => {
          this.empresaSelect.push(element.empresaId)
        });
        
        data.documentosproveedor.forEach(element => {
          if(element.claveDocumento === 'CSF'){
            this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
          }else if(element.claveDocumento === 'CD'){
            this.pdfSrc2 = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
          }else if(element.claveDocumento === 'CB'){
            this.pdfSrc3 = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
          }else if(element.claveDocumento === 'REP'){
            this.pdfSrc4 = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
          }else if (element.claveDocumento === 'OCF') {
            this.pdfSrc5 = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
            this.pdfName5 = element.archivo;
          }
        });
        this.loadingView = false
        this.getPaises()
        this.validarEmail(this.proveedorForm.value.correo);

        this.condicionPagoId = data.condiciondePagoId;
        this.getFormasPago(this.condicionPagoId,data.formaPagoId)
      }
    )
  }

  async getPaises(){
    this.paises = await lastValueFrom(this.provedorService.getPaises())
    // console.log(this.proveedorForm.value)
    this.getEstados()
  }

  async getEstados(){
    this.estados = await lastValueFrom(this.provedorService.getEstadosPorPais(this.proveedorForm.getRawValue().pais))
  }
  

  validarEmail($event){
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(emailRegex.test($event)){
      this.validEmail = true
      this.errorValidarCorreo = false
    }else{
      this.validEmail = false
      this.errorValidarCorreo = true
    }    
  }

  validateStep(opc){
    this.resetErrors()
    if(this.step === 1){
      if(this.proveedorForm.value.nombre !== '' && (this.proveedorForm.value.razonSocial !== '' && this.proveedorForm.value.tipoPersona=='2' || this.proveedorForm.value.razonSocial == '' && this.proveedorForm.value.tipoPersona=='1') && this.proveedorForm.value.rfc !== '' && this.proveedorForm.value.moneda !== ''){
        this.nextStep(opc)
      }else{
        this.mostrarError.nombre = this.proveedorForm.value.nombre !== '' ? false : true
        this.mostrarError.razonSocial = this.proveedorForm.value.razonSocial !== '' ? false : true
        this.mostrarError.rfc = this.proveedorForm.value.rfc !== '' ? false : true
        this.mostrarError.moneda = this.proveedorForm.value.moneda !== '' ? false : true
      }
    }else if(this.step === 2){
      if(this.proveedorForm.value.correo !== '' && this.proveedorForm.value.direccion !== '' && this.proveedorForm.value.telefono !== '' && this.proveedorForm.value.contacto !== ''){
        this.nextStep(opc)
      }else{
        this.mostrarError.correo = this.proveedorForm.value.correo !== '' ? false : true
        this.mostrarError.direccion = this.proveedorForm.value.direccion !== '' ? false : true
        this.mostrarError.telefono = this.proveedorForm.value.telefono !== '' ? false : true
        this.mostrarError.contacto = this.proveedorForm.value.contacto !== '' ? false : true
      }
    }else
     if(this.step === 3){
      if(this.proveedorForm.value.noCuenta !== '' && this.proveedorForm.value.tipoCompra !== '' && this.proveedorForm.value.tipoPersona !== '' && this.proveedorForm.value.regimenFiscal !== '' && this.proveedorForm.value.condicionesPago !== '' && this.proveedorForm.value.diasPago !== ''){
        this.nextStep(opc)
      }else{
        this.mostrarError.noCuenta = this.proveedorForm.value.noCuenta !== '' ? false : true
        this.mostrarError.tipoCompra = this.proveedorForm.value.tipoCompra !== '' ? false : true
        this.mostrarError.tipoPersona = this.proveedorForm.value.tipoPersona !== '' ? false : true
        this.mostrarError.regimenFiscal = this.proveedorForm.value.regimenFiscal !== '' ? false : true
        this.mostrarError.condicionesPago = this.proveedorForm.value.condicionesPago !== '' ? false : true
        this.mostrarError.diasPago = this.proveedorForm.value.diasPago !== '' ? false : true
      }
    }else{
      this.nextStep(opc)
    }
  }

  nextStep(opc){
    opc === 1 ? this.step ++ : this.step --
  }

  async guardarProveedor(){

    if(this.pdfName !== ''){
      await this.enviarArchivo(1)
    }

    if(this.pdfName2 !== ''){
      await this.enviarArchivo(2)
    }

    if(this.pdfName3 !== ''){
      await this.enviarArchivo(3)
    }

    if(this.pdfName4 !== ''){
      await this.enviarArchivo(4)
    }

    let body = {
      proveedorId: this.data.proveedor.proveedorId,
      claveProveedor: this.data.proveedor.claveProveedor,
      nombreProveedor: this.proveedorForm.value.nombre,
      razonSocial: this.proveedorForm.value.razonSocial,
      tipoProveedor: this.proveedorForm.value.tipoPersona,
      regimenFiscal: this.proveedorForm.value.regimenFiscal,
      // rfc: this.proveedorForm.value.rfc,
      moneda: this.proveedorForm.value.moneda,
      tipoCompra: this.proveedorForm.value.tipoCompra,
      direccion: this.proveedorForm.value.direccion,
      telefono: this.proveedorForm.value.telefono,
      email: this.proveedorForm.value.correo,
      contactoFacturacion: this.proveedorForm.value.contacto,
      numerodeCuenta: this.proveedorForm.value.noCuenta,
      nombreTitular: this.proveedorForm.value.titular,
      condiciondePagoId: this.proveedorForm.value.condicionesPago,
      formaPagoId: this.proveedorForm.value.formasPago,
      diasdePago: this.proveedorForm.value.diasPago,
      estatus: this.proveedorForm.value.estatus,
      idCIF: this.proveedorForm.value.idRfc,
      createdBy: localStorage.getItem('id'),
      documentosproveedor: [
        {
          "claveDocumento": "CSF",
          "archivo": this.proveedorForm.value.rfc+'-CSF.pdf',
          "estatus": true
        },
        {
            "claveDocumento": "CD",
            "archivo": this.proveedorForm.value.rfc+'-CD.pdf',
            "estatus": true
        },
        {
          "claveDocumento": "CB",
          "archivo": this.proveedorForm.value.rfc+'-CB.pdf',
          "estatus": true
        }
      ]
                  
    }

    if(this.proveedorForm.value.tipoCompra !== '1'){
      body.documentosproveedor.push({
        "claveDocumento": "REP",
        "archivo": this.proveedorForm.value.rfc+'-REP.pdf',
        "estatus": true
      })
    }

    this.provedorService.putGuardarProveedor(body).subscribe(
      data => {
        if(data.code === 400){
          const dialogRef = this.dialog.open(ErrorDialogComponent, {
            width: 'auto',
            data: {
              message: data.message
            }
          });
        }else if(data.code === 200){
          this.dialogRef.close({event: 1, data: data})
        }
      }
    )
  }

  enviarArchivo(opc){
    const formData = new FormData();
    if(opc === 1){
      formData.append('fileProvider', this.selectedFile);
    }else if(opc === 2){
      formData.append('fileProvider', this.selectedFile2);
    }else if(opc === 3){
      formData.append('fileProvider', this.selectedFile3);
    }else if(opc === 4){
      formData.append('fileProvider', this.selectedFile4);
    }
    this.provedorService.enviarPdf(formData).subscribe(
      data => {

      }
    )
  }

  closeDialog(){
    this.dialogRef.close({event: 2})
  }

  onFileSelected(event: any, opc): void {
    const file: File = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      this.previewPDF(file, opc, event);
    } else {
      const dialogRef = this.dialog.open(ErrorDialogComponent, {
        width: 'auto',
        data: {
          message: 'Por favor, selecciona un archivo PDF'
        }
      });
    }
  }

  previewPDF(file: File, opc, $event): void {
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const pdfData = e.target.result;
      const blob = new Blob([pdfData], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      if(opc === 1){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-CSF.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName = auxFile.name
        this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile = auxFile;
      }else if(opc === 2){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-CD.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName2 = auxFile.name
        this.pdfSrc2 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile2 = auxFile;
      }else if(opc === 3){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-CB.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName3 = auxFile.name
        this.pdfSrc3 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile3 = auxFile;
      }else if(opc === 4){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-REP.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName4 = auxFile.name
        this.pdfSrc4 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile4 = auxFile;
      }
    };

    reader.readAsArrayBuffer(file);
  }

  resetErrors(){
    this.mostrarError = {
      nombre: false,
      razonSocial: false,
      rfc: false,
      moneda: false,
      correo: false,
      direccion: false,
      telefono: false,
      contacto: false,
      noCuenta: false, 
      tipoCompra: false,
      tipoPersona: false,
      regimenFiscal: false,
      condicionesPago: false,
      diasPago: false,
      titular: false,
      idCif:false
    }
  }

  resetUploadFile(opc){
    if(opc === 1){
      this.pdfName = ''
      delete this.pdfSrc
      delete this.selectedFile
    }else if(opc === 2){
      this.pdfName2 = ''
      delete this.pdfSrc2
      delete this.selectedFile2
    }else if(opc === 3){
      this.pdfName3 = ''
      delete this.pdfSrc3
      delete this.selectedFile3
    }else if(opc === 4){
      this.pdfName4 = ''
      delete this.pdfSrc4
      delete this.selectedFile4
    }
    // this.file_loaded = []; 
    // this.wrongFileExtension = false
  }

  repseHabilitado(){
    return this.proveedorForm.value.tipoCompra !== '1' ? false : true 
  }
}
